import React from 'react';

const LeftLessonRenderer = ({
  content,
}) => {
  if (!content) {
    return null;
  }

  return (
    <div className="conta-primara-left-renderer">

      {content.eyebrow && (
        <span className="conta-primara-category">
          {content.eyebrow}
        </span>
      )}

      {content.title && (
        <h1>
          {content.title}
        </h1>
      )}

      {Array.isArray(content.content) &&
        content.content.map((item, index) => (
          <div
            key={index}
            dangerouslySetInnerHTML={{
              __html: item,
            }}
          />
        ))}

      {content.highlight && (
        <div className="conta-primara-example">

          <span>
            {content.highlight.title}
          </span>

          <p>
            {content.highlight.text}
          </p>

        </div>
      )}

    </div>
  );
};

export default LeftLessonRenderer;